(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

  class StickyHeader extends HTMLElement {

    constructor() {

      super();

    }



    connectedCallback() {

      this.header = document.getElementById('shopify-section-header');

      this.headerBounds = {};

      this.currentScrollTop = 0;

      this.preventReveal = false;

      this.predictiveSearch = this.querySelector('predictive-search');



      this.onScrollHandler = this.onScroll.bind(this);

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;



      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);



      this.createObserver();

    }



    disconnectedCallback() {

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.removeEventListener('scroll', this.onScrollHandler);

    }



    createObserver() {

      let observer = new IntersectionObserver((entries, observer) => {

        this.headerBounds = entries[0].intersectionRect;

        observer.disconnect();

      });



      observer.observe(this.header);

    }



    onScroll() {

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;



      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;



      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {

        if (!this.preventReveal) {

          requestAnimationFrame(this.reveal.bind(this));

        } else {

          window.clearTimeout(this.isScrolling);



          this.isScrolling = setTimeout(() => {

            this.preventReveal = false;

          }, 66);



          requestAnimationFrame(this.hide.bind(this));

        }

      } else if (scrollTop <= this.headerBounds.top) {

        requestAnimationFrame(this.reset.bind(this));

      }





      this.currentScrollTop = scrollTop;

    }



    hide() {

      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');

      this.closeMenuDisclosure();

      this.closeSearchModal();

    }



    reveal() {

      this.header.classList.add('shopify-section-header-sticky', 'animate');

      this.header.classList.remove('shopify-section-header-hidden');

    }



    reset() {

      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

    }



    closeMenuDisclosure() {

      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');

      this.disclosures.forEach(disclosure => disclosure.close());

    }



    closeSearchModal() {

      this.searchModal = this.searchModal || this.header.querySelector('details-modal');

      this.searchModal.close(false);

    }

  }



  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    

window.addEventListener('DOMContentLoaded', (event) => {

  $('#check_tandc').on('click',function(){
  $('.accept_lebel').css('color','red')
  $('.accept_lebel').show();
})
$('#form-button').on('click',function(){
  $('.accept_lebel').hide();
})
  
  
  
  
  $('.custom-checkbox span').on('click',function(e){
  let id = $(this).attr('attr');
  console.log('#liId'+id)
  $('#liId'+id).trigger("click");
  showaddtocart()
})

$(".input_with_text li").click(function (e) {
  var cb = $(this).find(":checkbox")[0];
  if (e.target != cb) cb.checked = !cb.checked;
  $(this).toggleClass("selected", cb.checked);
  showaddtocart()
});

function showaddtocart(){
  if ($('.tandc_allli:checked').length == $('.tandc_allli').length) {
    $('#check_tandc').hide()
    $('#form-button').removeClass('btn_hide')
 }else{
  $('#check_tandc').show()
  $('#form-button').addClass('btn_hide')
 }
}

});


  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-qc"]) return;
  try {
    

window.addEventListener('DOMContentLoaded', (event) => {

  $('#DrugCode-1234').on('click', function(e) {
    $('sticky-header').css('z-index','0');
  });
  $('.product-popup-modal__toggle').on('click', function(e) {
    $('.header-wrapper').css('z-index','9999');
  });

  $('[aria-label="Close"]').on('click', function(e) {
    $('sticky-header').css('z-index','2');
   

  });

  $('#check_tandc').on('click',function(){
    $('.accept_lebel').css('color','red')
    $('.accept_lebel').show();
  })
  $('#form-button').on('click',function(){
    $('.accept_lebel').hide();
  })
  $('.custom-checkbox span').on('click',function(e){
    let id = $(this).attr('attr');
    console.log('#liId'+id)
    $('#liId'+id).trigger("click");
    showaddtocart()
  })

  $(".input_with_text li").click(function (e) {
    var cb = $(this).find(":checkbox")[0];
    if (e.target != cb) cb.checked = !cb.checked;
    $(this).toggleClass("selected", cb.checked);
    showaddtocart()
  });

  function showaddtocart(){
    if ($('.tandc_allli:checked').length == $('.tandc_allli').length) {
      $('#check_tandc').hide()
      $('#form-button').removeClass('btn_hide')
    }else{
      $('#check_tandc').show()
      $('#form-button').addClass('btn_hide')
    }
  }

});


  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medvisit-mental-health-hero"] && !Shopify.designMode) return;
  try {
    

if($('#medReviewPage .shopify-section:nth-child(3) .content_top ul')) {
    $('#medReviewPage .shopify-section:nth-child(3) .content_top ul').find('br').remove(); 
}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mental-health-hero"] && !Shopify.designMode) return;
  try {
    

if($('#medReviewPage .shopify-section:nth-child(3) .content_top ul')) {
    $('#medReviewPage .shopify-section:nth-child(3) .content_top ul').find('br').remove(); 
}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mfb-hero"] && !Shopify.designMode) return;
  try {
    

if($('#medReviewPage .shopify-section:nth-child(3) .content_top ul')) {
    $('#medReviewPage .shopify-section:nth-child(3) .content_top ul').find('br').remove(); 
}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            console.log('recommendation !!!!')
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              console.log("recommended product!")
              this.getLocationBasedQty(this);
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }

    getLocationBasedQty(containerEl) {
      const variants = containerEl.querySelectorAll('.quick-add[data-available=""]');
      const location = Alpine.store('location').city;
      
      if (variants.length > 0) {
        const variantsElArr = Array.from(variants);
        const variantsArr = variantsElArr.map(variant => {
          return parseInt(variant.getAttribute('data-variant-id'));
        });
    
        fetch(`https://mednow-inventory.herokuapp.com/all-variants/?variants=${JSON.stringify(variantsArr)}&location=${location}`)
        .then((response) => response.json())
        .then((data) => {
          console.log("bulk req => ", data);
          data.forEach(vr => {
            const els = containerEl.querySelectorAll(`[data-variant-id="${vr.variant}"]`);
            els.forEach(el => {
              el.setAttribute('data-available', vr.quantity);
            })
          })
        });
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-collection-product-list"]) return;
  try {
    
  window.addEventListener('load', (event) => {
    document.getElementById('product-grid-title').scrollIntoView({
      behavior: 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["qc-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-qc-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs2"]) return;
  try {
    

var coll = document.getElementsByClassName("collapbtn");
var i;

for (i = 0; i < coll.length; i++) {
                            coll[i].addEventListener("click", function() {
                            this.classList.toggle("active");
                            var content = this.nextElementSibling;
                            if (content.style.maxHeight){
                            content.style.maxHeight = null;
                            } else {
                            content.style.maxHeight = content.scrollHeight + "px";
                            } 
                            });
                            }
                                

  } catch(e) { console.error(e); }
})();
})();
